import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'CardPointData';

  static fields = {
    id: attr(),
    cardId: fk({
      to: 'Card',
      as: 'card',
      relatedName: 'cardPointDatas',
    }),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'cardPointDatas',
    }),
    ccdId: fk({
      to: 'ContentCardDefault',
      as: 'contentCardDefault',
      relatedName: 'cardPointDatas',
    }),
    views: attr(),
    closed: attr(),
    closedAt: attr(),
    createdAt: attr(),
  };

  static reducer({ type, payload }, CardPointData) {
    switch (type) {
      case ActionTypes.CARD_POINT_DATA_FETCH__SUCCESS: {
        const { cardId, pointSystemId, item } = payload;

        CardPointData.filter({ cardId, pointSistemId: pointSystemId }).delete();

        if (item) {
          CardPointData.upsert(item);
        }

        break;
      }
      case ActionTypes.CARD_POINT_DATA_UPSERT__SUCCESS:
        CardPointData.upsert(payload.item);

        break;
      case ActionTypes.CARD_POINT_DATA_COMPLETE__SUCCESS:
        if (payload.item) {
          const existing = CardPointData.withId(payload.item.id);
          if (existing) {
            existing.update(payload.item);
          } else {
            CardPointData.upsert(payload.item);
          }
        }

        break;
      case ActionTypes.CARD_POINT_DATA_UNCOMPLETE__SUCCESS:
        CardPointData.upsert(payload.item);

        break;
      default:
    }
  }
}

